var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.253,
    height: 75.729,
    viewBox: "0 0 58.253 75.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3a7ff5;opacity:0.4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M41.7,3.375H14.032A7.281,7.281,0,0,0,6.75,10.657V71.822A7.281,7.281,0,0,0,14.032,79.1h43.69A7.281,7.281,0,0,0,65,71.822V26.676ZM38.789,29.589V9.2L59.177,29.589Z",
    transform: "translate(-6.75 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentImg1);
export default __webpack_public_path__ + "static/media/document-img1.22be3d99ddfb1229d33ccb66ea8ef826.svg";
export { ForwardRef as ReactComponent };